import { required, TRequiredCodec } from "../../../shared/src/codecs/types/required";
import { BuyerSubmitsNewOfferFormEditable, TBuyerSubmitsNewOfferFormEditableCodec } from "../formEditable/BuyerSubmitsNewOfferFormEditable";
import { BuyerUpdatesConveyancerDetailsFormEditable, TBuyerUpdatesConveyancerDetailsFormEditableCodec } from "../formEditable/BuyerUpdatesConveyancerDetailsFormEditable";
import { BuyerUpdatesMortgageBrokerDetailsFormEditable, TBuyerUpdatesMortgageBrokerDetailsFormEditableCodec } from "../formEditable/BuyerUpdatesMortgageBrokerDetailsFormEditable";
import { BuyerUpdatesProofOfFundsFormEditable, TBuyerUpdatesProofOfFundsFormEditableCodec } from "../formEditable/BuyerUpdatesProofOfFundsFormEditable";
import { BuyerUpdatesClientDetailsFormEditable, TBuyerUpdatesClientDetailsFormEditableCodec } from "../formEditable/BuyerUpdatesClientDetailsFormEditable";
import { PublicOffersPageFormIO, TPublicOffersPageFormIOCodec } from "../formIO/PublicOffersPageFormIO";
import { GetProofOfFundsDocumentsFormIO, TGetProofOfFundsDocumentsFormIOCodec } from "../formIO/GetProofOfFundsDocumentsFormIO";

export const PublicOffersPagePartial: TRequiredCodec<{
    data: TPublicOffersPageFormIOCodec,
    new_offer: TBuyerSubmitsNewOfferFormEditableCodec,
    conveyancer_form: TBuyerUpdatesConveyancerDetailsFormEditableCodec,
    mortgage_broker_form: TBuyerUpdatesMortgageBrokerDetailsFormEditableCodec,
    proof_of_funds_form: TBuyerUpdatesProofOfFundsFormEditableCodec,
    client_details_form: TBuyerUpdatesClientDetailsFormEditableCodec,
    proof_of_funds_documents: TGetProofOfFundsDocumentsFormIOCodec
}> = required({
    data: PublicOffersPageFormIO,
    new_offer: BuyerSubmitsNewOfferFormEditable,
    conveyancer_form: BuyerUpdatesConveyancerDetailsFormEditable,
    mortgage_broker_form: BuyerUpdatesMortgageBrokerDetailsFormEditable,
    proof_of_funds_form: BuyerUpdatesProofOfFundsFormEditable,
    client_details_form: BuyerUpdatesClientDetailsFormEditable,
    proof_of_funds_documents: GetProofOfFundsDocumentsFormIO
});

export type TPublicOffersPagePartialCodec = typeof PublicOffersPagePartial;
